import { ProductBlock } from "./product-block";
import { ThreeColumnFlyInBlock } from "./three-column-fly-in-block";
import { ProductConfigureBlock } from "./product-configure-block";
import { MediaBlock } from "./media-block";
import { Helpers } from "../helpers";

export class ProductPage {
    private static readonly LOADED_CLASS = "loaded";

    public static readonly Debug = true;
    
    private $window = $(window);
    private body = $("body");
    private page: JQuery;

    private lastYPoint: number;
    private movingDown: boolean;

    private oldWidth: number
    private oldHeight: number;
    private resizeTimer: any;

    private blocks: ProductBlock[];

    constructor() {
        this.page = $(".product-visual-page");

        //new Helpers().onImagesLoaded($('#main')).then(() => {
            this.oldWidth = $(window).width();
            this.oldHeight = $(window).height();

            if (!this.inEdit()) {
                this.setListeners();
            }

            this.init();
        //});
    }

    public inEdit(): boolean {
        return $("html").hasClass("in-edit");
    }

    private init() {
        // Do not show submenu on this page

        this.onScroll();
        this.initBlocks();
        this.page.addClass(ProductPage.LOADED_CLASS);
    }

    private initBlocks() {
        this.blocks = [];

        let block: ProductBlock;

        $(`.${ProductBlock.CLASS_NAME}`).each((i, e) => {
            const blockElement = $(e);

            if (blockElement.hasClass(ThreeColumnFlyInBlock.CLASS_NAME)) {
                block = new ThreeColumnFlyInBlock(e);
            }
            else if (blockElement.hasClass(ProductConfigureBlock.CLASS_NAME)) {
                block = new ProductConfigureBlock(e);
            }
            else if (blockElement.hasClass(MediaBlock.CLASS_NAME)) {
                block = new MediaBlock(e);
            }
            else {
                block = new ProductBlock(e);    
            }

            block.initiate();
            this.blocks.push(block);
        })
    }

    private setListeners() {
        this.$window.on("scroll", this.onScroll.bind(this));
        this.$window.on("resize", this.onResize.bind(this));
    }
    
    private onScroll() {
        if (this.lastYPoint < window.pageYOffset) {
            this.movingDown = true;
            this.body.addClass("moving-down");
            this.body.removeClass("moving-up");
        }
        else {
            this.movingDown = false;
            this.body.removeClass("moving-down");
            this.body.addClass("moving-up");
        }

        this.lastYPoint = window.pageYOffset;
    }

    private onResize() {
        clearTimeout(this.resizeTimer);

        this.resizeTimer = setTimeout(() => {

            // Do not trigger when address bar dissappear on iOS
            if (this.oldWidth !== this.$window.width() || this.oldHeight !== this.$window.height()) {
                this.page.removeClass(ProductPage.LOADED_CLASS);
                this.init();
            }

            this.oldWidth = this.$window.width();
            this.oldHeight = this.$window.height();

        }, 250);
    }
}

var productPage = new ProductPage();